import {SpiroData} from "../models/SpiroData";

const brokenData: SpiroData = {
    briefResult: {},
    header: {
        age: {years: 30, months: 6, days: 0},
        appVersion: "V 1.1.1-gp (11001)",
        dateTime: "2025-08-06T17:46:18.069+03:00",
        deviceFwVersion: "Ver P1.28 SPR 3 Feb  5 2023",
        deviceName: "Binora SPR",
        deviceNumber: "2059",
        formatId: "spr.json v.2.0",
        gender: 0,
        height: 170.0,
        heightUnits: 1,
        sampleRate: 100,
        unitsPerLiter: 1000000,
        userDeviceId: "SM-A405FN (SDK 30)",
        weight: 50.0,
        weightUnits: 2
    },
    records: []
};

const testData: SpiroData = {
    header: {
        age: {
            years: 35,
            months: 4,
            days: 0
        },
        appVersion: "0.0",
        dateTime: "2022-02-25T10:35:54.18+02:00",
        deviceFwVersion: "Dummy spiro data v.1.0 Feb 25 2022",
        deviceName: "Dummy spiro device",
        deviceNumber: "0000",
        formatId: "spr.json v.2.0",
        gender: 1,
        height: 180.0,
        heightUnits: 1,
        sampleRate: 100,
        unitsPerLiter: 1000000,
        userDeviceId: "Dummy device",
        weight: 95.0,
        weightUnits: 2
    },
    briefResult: {
        fvcResult: {
            fef25: {
                lln: 0.0,
                measured: 5.5229,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fef2575: {
                lln: 2.4003253154719415,
                "measured": 2.526992134831461,
                "percentPredicted": 66.54291456704851,
                "prSystem": 1,
                "predicted": 3.797537500833795,
                "zScore": -1.4819373366676907
            },
            fef50: {
                lln: 0.0,
                measured: 3.1074,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fef75: {
                lln: 0.832761106868483,
                measured: 1.1114000000000002,
                percentPredicted: 67.44958364722649,
                prSystem: 1,
                predicted: 1.6477492371381015,
                zScore: -0.9818128809442976
            },
            fet: {
                lln: 0.0,
                measured: 4.05,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fev0_75: {
                lln: 0.0,
                measured: 2.727292,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fev0_75Fvc: {
                lln: 0.0,
                measured: 60.63281700542858,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fev1: {
                lln: 2.949000581988755,
                measured: 3.154127,
                percentPredicted: 85.7054749324187,
                prSystem: 1,
                predicted: 3.680193129420404,
                zScore: -1.189246171996438
            },
            fev1Fev6: {
                lln: 75.9928,
                measured: 70.12215971112788,
                percentPredicted: 82.69805256463137,
                prSystem: 2,
                predicted: 84.793,
                zScore: -2.734049007266912
            },
            fev1Fvc: {
                lln: 72.01634624578493,
                measured: 70.12215971112788,
                percentPredicted: 84.2108669868871,
                prSystem: 1,
                predicted: 83.26972779183825,
                zScore: -1.8806072260314546
            },
            fev2: {
                lln: 0.0,
                measured: 3.951228,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fev3: {
                lln: 0.0,
                measured: 4.299416,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            },
            fev6: {
                lln: 3.52558675,
                measured: 4.498046,
                percentPredicted: 104.31372135221251,
                prSystem: 2,
                predicted: 4.31203675,
                zScore: 0.387888829550513
            },
            fvc: {
                lln: 3.5627622765234106,
                measured: 4.498046,
                percentPredicted: 100.99034941033092,
                prSystem: 1,
                predicted: 4.453936466467822,
                zScore: 0.07981711429538725
            },
            pef: {
                lln: 5.811049,
                measured: 5.6166,
                percentPredicted: 72.0629613654652,
                prSystem: 2,
                predicted: 7.79401775,
                zScore: -1.8008176427389484
            },
            pefTime: {
                lln: 0.0,
                measured: 0.19,
                percentPredicted: 0.0,
                prSystem: 0,
                predicted: 0.0,
                zScore: 0.0
            }
        }
    },
    records: [{
        result:
            {
                fvcResult:
                    {
                        fef25: {
                            lln: 0.0,
                            measured: 4.4209,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fef2575: {
                            lln: 2.4003253154719415,
                            measured: 2.499616091954023,
                            percentPredicted: 65.82202523096092,
                            prSystem: 1,
                            predicted: 3.797537500833795,
                            zScore: -1.5168896630580697
                        },
                        fef50: {
                            lln: 0.0,
                            measured: 3.1074,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fef75: {
                            lln: 0.832761106868483,
                            measured: 1.0652,
                            percentPredicted: 64.64575895359515,
                            prSystem: 1,
                            predicted: 1.6477492371381015,
                            zScore: -1.0822602199605629
                        },
                        fet: {
                            lln: 0.0,
                            measured: 4.05,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fev0_75: {
                            lln: 0.0,
                            measured: 2.571636,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fev0_75Fvc: {
                            lln: 0.0,
                            measured: 59.127148720769064,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fev1: {
                            lln: 2.949000581988755,
                            measured: 3.013684,
                            percentPredicted: 81.8892893394056,
                            prSystem: 1,
                            predicted: 3.680193129420404,
                            zScore: -1.5017963123461502
                        },
                        fev1Fev6: {
                            lln: 75.9928,
                            measured: 69.2907324619045,
                            percentPredicted: 81.71751496220737,
                            prSystem: 2,
                            predicted: 84.793,
                            zScore: -2.8889932913429948
                        },
                        fev1Fvc: {
                            lln: 72.01634624578493,
                            measured: 69.2907324619045,
                            percentPredicted: 83.21239218545406,
                            prSystem: 1,
                            predicted: 83.26972779183825,
                            zScore: -1.9804570066262135
                        },
                        fev2: {
                            lln: 0.0,
                            measured: 3.832235,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fev3: {
                            lln: 0.0,
                            measured: 4.169355,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        },
                        fev6: {
                            lln: 3.52558675,
                            measured: 4.349332,
                            percentPredicted: 100.8649103002195,
                            prSystem: 2,
                            predicted: 4.31203675,
                            zScore: 0.07777253480831703
                        },
                        fvc: {
                            lln: 3.5627622765234106,
                            measured: 4.349332,
                            percentPredicted: 97.65141538826714,
                            prSystem: 1,
                            predicted: 4.453936466467822,
                            zScore: -0.18984488521925674
                        },
                        pef: {
                            lln: 5.811049,
                            measured: 4.4235999999999995,
                            percentPredicted: 56.75635008657761,
                            prSystem: 2,
                            predicted: 7.79401775,
                            zScore: -2.787479686707115
                        },
                        pefTime: {
                            lln: 0.0,
                            measured: 0.19,
                            percentPredicted: 0.0,
                            prSystem: 0,
                            predicted: 0.0,
                            zScore: 0.0
                        }
                    }
            },
        volumes: [5267, 7397, 9937, 12739, 15461, 18226, 20907, 23432, 25782, 27955, 29920, 31705, 33298, 34711, 35918, 36994, 37962, 38812, 39531, 40187, 40794, 41358, 41893, 42366, 42772, 43140, 43436, 43675, 43885, 44039, 44155, 44230, 44236, 44209, 44184, 44163, 44126, 44092, 44002, 43876, 43723, 43511, 43280, 42993, 42683, 42330, 41867, 41352, 40768, 40106, 39355, 38514, 37653, 36734, 35808, 34921, 34097, 33275, 32507, 31779, 31074, 30368, 29697, 29044, 28413, 27792, 27158, 26526, 25939, 25324, 24735, 24174, 23645, 23117, 22602, 22121, 21630, 21172, 20715, 20296, 19872, 19477, 19098, 18709, 18348, 18009, 17671, 17360, 17069, 16788, 16520, 16241, 15978, 15730, 15475, 15232, 14987, 14752, 14514, 14284, 14058, 13850, 13637, 13431, 13225, 13025, 12829, 12640, 12457, 12280, 12108, 11942, 11801, 11645, 11489, 11338, 11191, 11047, 10924, 10788, 10652, 10522, 10412, 10289, 10167, 10046, 9944, 9830, 9714, 9616, 9504, 9394, 9300, 9197, 9093, 9006, 8911, 8818, 8739, 8651, 8561, 8484, 8399, 8326, 8241, 8152, 8077, 7990, 7916, 7825, 7747, 7658, 7583, 7487, 7390, 7307, 7215, 7136, 7048, 6974, 6890, 6819, 6759, 6681, 6614, 6536, 6471, 6395, 6330, 6255, 6191, 6116, 6053, 5999, 5923, 5858, 5784, 5721, 5668, 5599, 5540, 5474, 5417, 5369, 5306, 5252, 5206, 5148, 5099, 5042, 4994, 4953, 4902, 4858, 4821, 4774, 4733, 4699, 4656, 4620, 4589, 4546, 4509, 4478, 4441, 4409, 4383, 4360, 4321, 4288, 4260, 4223, 4192, 4165, 4128, 4097, 4071, 4048, 4014, 3984, 3959, 3924, 3893, 3868, 3846, 3811, 3782, 3757, 3736, 3703, 3675, 3652, 3621, 3595, 3573, 3554, 3526, 3501, 3481, 3463, 3438, 3416, 3397, 3381, 3368, 3343, 3322, 3304, 3288, 3266, 3247, 3230, 3216, 3194, 3175, 3159, 3145, 3133, 3112, 3094, 3079, 3066, 3054, 3034, 3016, 3001, 2988, 2977, 2959, 2943, 2929, 2918, 2908, 2891, 2876, 2864, 2853, 2844, 2828, 2815, 2804, 2794, 2786, 2769, 2754, 2742, 2731, 2723, 2715, 2694, 2676, 2661, 2649, 2638, 2628, 2606, 2586, 2569, 2555, 2543, 2533, 2509, 2489, 2472, 2457, 2444, 2434, 2425, 2399, 2377, 2359, 2343, 2330, 2318, 2309, 2285, 2266, 2249, 2235, 2222, 2212, 2203, 2196, 2171, 2149, 2131, 2116, 2103, 2091, 2082, 2074, 2043, 2017, 1995, 1977, 1961, 1947, 1935, 1926, 1917, 1887, 1862, 1840, 1822, 1806, 1793, 1781, 1772, 1764, 1757, 1724, 1696, 1672, 1652, 1635, 1621, 1608, 1598, 1589, 1581, 1575, 1542, 1515, 1492, 1472, 1455, 1440, 1428, 1418, 1409, 1402, 1395, 1390, 1385, 1355, 1330, 1308, 1289, 1274, 1260, 1249, 1239, 1231, 1224, 1218, 1213, 1209, 1205, 1202, 1181, 1162, 1147, 1134, 1122, 1113, 1105, 1098, 1092, 1087, 1083, 1079, 1076, 1073, 1071, 1069]
    }, {
        result: {
            fvcResult: {
                fef25: {
                    lln: 0.0,
                    measured: 5.5229,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fef2575: {
                    lln: 2.4003253154719415,
                    measured: 2.526992134831461,
                    percentPredicted: 66.54291456704851,
                    prSystem: 1,
                    predicted: 3.797537500833795,
                    zScore: -1.4819373366676907
                },
                fef50: {
                    lln: 0.0,
                    measured: 2.9638,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fef75: {
                    lln: 0.832761106868483,
                    measured: 1.1114000000000002,
                    percentPredicted: 67.44958364722649,
                    prSystem: 1,
                    predicted: 1.6477492371381015,
                    zScore: -0.9818128809442976
                },
                fet: {
                    lln: 0.0,
                    measured: 4.05,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fev0_75: {
                    lln: 0.0,
                    measured: 2.727292,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fev0_75Fvc: {
                    lln: 0.0,
                    measured: 60.63281700542858,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fev1: {
                    lln: 2.949000581988755,
                    measured: 3.154127,
                    percentPredicted: 85.7054749324187,
                    prSystem: 1,
                    predicted: 3.680193129420404,
                    zScore: -1.189246171996438
                },
                fev1Fev6: {
                    lln: 75.9928,
                    measured: 70.12215971112788,
                    percentPredicted: 82.69805256463137,
                    prSystem: 2,
                    predicted: 84.793,
                    zScore: -2.734049007266912
                },
                fev1Fvc: {
                    lln: 72.01634624578493,
                    measured: 70.12215971112788,
                    percentPredicted: 84.2108669868871,
                    prSystem: 1,
                    predicted: 83.26972779183825,
                    zScore: -1.8806072260314546
                },
                fev2: {
                    lln: 0.0,
                    measured: 3.951228,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fev3: {
                    lln: 0.0,
                    measured: 4.299416,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                },
                fev6: {
                    lln: 3.52558675,
                    measured: 4.498046,
                    percentPredicted: 104.31372135221251,
                    prSystem: 2,
                    predicted: 4.31203675,
                    zScore: 0.387888829550513
                },
                fvc: {
                    lln: 3.5627622765234106,
                    measured: 4.498046,
                    percentPredicted: 100.99034941033092,
                    prSystem: 1,
                    predicted: 4.453936466467822,
                    zScore: 0.07981711429538725
                },
                pef: {
                    lln: 5.811049,
                    measured: 5.6166,
                    percentPredicted: 72.0629613654652,
                    prSystem: 2,
                    predicted: 7.79401775,
                    zScore: -1.8008176427389484
                },
                pefTime: {
                    lln: 0.0,
                    measured: 0.18,
                    percentPredicted: 0.0,
                    prSystem: 0,
                    predicted: 0.0,
                    zScore: 0.0
                }
            }
        },
        volumes: [5436, 7888, 10790, 14161, 17551, 20780, 23822, 26616, 29296, 31953, 34616, 37295, 39993, 42560, 44914, 46988, 48790, 50324, 51621, 52728, 53699, 54555, 55271, 55724, 56091, 56166, 56066, 55729, 55229, 54511, 53607, 52694, 51681, 50623, 49455, 48226, 46948, 45629, 44342, 43130, 41970, 40899, 39899, 38991, 38114, 37267, 36396, 35592, 34817, 34034, 33301, 32612, 31950, 31342, 30760, 30206, 29638, 29100, 28579, 28072, 27578, 27082, 26591, 26107, 25640, 25200, 24794, 24369, 23950, 23526, 23122, 22698, 22273, 21877, 21448, 21020, 20568, 20155, 19733, 19349, 18998, 18644, 18310, 18000, 17683, 17387, 17114, 16844, 16568, 16309, 16054, 15815, 15584, 15365, 15142, 14904, 14672, 14439, 14204, 13974, 13761, 13558, 13377, 13210, 13055, 12924, 12779, 12643, 12501, 12367, 12231, 12097, 11950, 11793, 11624, 11480, 11297, 11114, 10937, 10770, 10628, 10486, 10351, 10223, 10115, 9996, 9877, 9775, 9655, 9530, 9424, 9287, 9139, 9013, 8854, 8686, 8543, 8384, 8249, 8106, 7984, 7863, 7760, 7657, 7557, 7473, 7384, 7308, 7222, 7149, 7060, 6984, 6893, 6815, 6724, 6647, 6582, 6496, 6424, 6349, 6286, 6223, 6169, 6115, 6069, 6029, 5985, 5947, 5905, 5870, 5831, 5799, 5771, 5732, 5700, 5654, 5616, 5583, 5561, 5543, 5507, 5476, 5450, 5409, 5375, 5335, 5302, 5273, 5232, 5198, 5157, 5123, 5094, 5054, 5021, 4992, 4951, 4916, 4887, 4841, 4802, 4769, 4719, 4676, 4639, 4586, 4540, 4502, 4451, 4408, 4371, 4322, 4281, 4246, 4216, 4174, 4138, 4108, 4070, 4038, 4010, 3977, 3949, 3925, 3904, 3873, 3847, 3824, 3805, 3776, 3751, 3729, 3700, 3675, 3654, 3636, 3610, 3587, 3568, 3551, 3524, 3502, 3483, 3466, 3444, 3424, 3408, 3394, 3373, 3354, 3339, 3325, 3314, 3294, 3277, 3263, 3251, 3232, 3217, 3203, 3192, 3176, 3162, 3150, 3141, 3132, 3117, 3104, 3093, 3083, 3075, 3060, 3047, 3036, 3026, 3009, 2995, 2982, 2972, 2963, 2946, 2931, 2919, 2908, 2899, 2892, 2870, 2852, 2837, 2824, 2813, 2790, 2771, 2754, 2740, 2729, 2704, 2683, 2666, 2651, 2638, 2627, 2602, 2581, 2562, 2547, 2534, 2522, 2513, 2486, 2464, 2445, 2428, 2414, 2403, 2393, 2367, 2345, 2327, 2311, 2298, 2287, 2277, 2254, 2234, 2217, 2203, 2191, 2180, 2171, 2164, 2142, 2123, 2107, 2093, 2081, 2071, 2063, 2056, 2034, 2014, 1998, 1985, 1973, 1963, 1954, 1947, 1941, 1918, 1899, 1883, 1869, 1857, 1847, 1838, 1831, 1825, 1819, 1796, 1777, 1760, 1746, 1734, 1724, 1715, 1707, 1701, 1696, 1672, 1652, 1635, 1621, 1608, 1598, 1589, 1581, 1575, 1569, 1565, 1543, 1525, 1509, 1496, 1484, 1475, 1466, 1459, 1454, 1449, 1444, 1441, 1417, 1396, 1379, 1364, 1352, 1341, 1332, 1325, 1318, 1313, 1308, 1304, 1301, 1298]
    }]
}

export const spiroTestData = testData;
